import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireThrottle } from "../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js";
var throttleExports = requireThrottle();
const throttle = /* @__PURE__ */ getDefaultExportFromCjs(throttleExports);
export {
  throttle as default
};
//# sourceMappingURL=throttle.js.map
